const ths = [
  {
    id: 1,
    label: 'Finished',
    intlKey: 'table.finished',
    sortable: false,
    sortableId: 'id'
  },
  // {
  //   id: 2,
  //   label: 'Note for AL',
  //   intlKey: 'table.note_for_al',
  //   sortable: false,
  //   sortableId: 'person.firstName'
  // },
  {
    id: 4,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false,
    right: true
  }
]

export default ths
